import { useMemo } from 'react';
import { useCampaignSettingsSelector } from './useCampaignSettingsSelector';

export const useNameSelector = () => {
  const settings = useCampaignSettingsSelector();
  return useMemo(() => settings.name ?? '', [settings.name]);
};
